const actionTypes = require('constants/actionTypes');

const switchGlobalErrorModal = data => {
    return {
        type: actionTypes.SHOW_GLOBAL_ERROR_MODAL,
        data,
    };
};

const setCallbackGlobalErrorModal = data => {
    return {
        type: actionTypes.SET_CALLBACK_GLOBAL_ERROR_MODAL,
        data,
    };
};

const setInfoGlobalErrorModal = data => {
    return {
        type: actionTypes.SET_INFO_GLOBAL_ERROR_MODAL,
        data,
    };
};

export default {
    switchGlobalErrorModal,
    setInfoGlobalErrorModal,
    setCallbackGlobalErrorModal,
};
